import "./home-page.scss";

type HomePageProps = {};

const HomePage = (props: HomePageProps) => {
  return (
    <>
      <div className="home-page page">
        <div className="home-page__image"></div>
        <h1 className="home-page__header page__header">
          Прoфесионално портфолио <br /> на Евгения Арнаудова
        </h1>
        <p className="home-page__my-moto">
          “Умът не изисква пълнене като бутилка, по – скоро също като дървото,
          той изисква само подпалки, за да се създаде в него импулс да мисли
          самостоятелно и пламенно желание за истината“ - Плутарх
        </p>
      </div>
    </>
  );
};

export default HomePage;
